import Swiper from 'swiper/bundle';

/**
 * ReviewSlider - A class for handling functionality
 */
class ReviewSlider {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const elements = document.querySelectorAll('.qte-module-slider .swiper');

		for (const element of elements) {
			const instance = new ReviewSlider(element);
			instance.init();
		}
	}

	/**
	 * Constructor method
	 *
	 * @param {HTMLElement} element
	 * @return {void}
	 */
	constructor(element) {
		this.element = element;
	}

	/**
	 * Initialize method
	 * Method to initialize a new swiper slider
	 */
	init() {
		const productsSlider = new Swiper(this.element, {
			slidesPerView: 1,
			slidesToSwipe: 1,
			spaceBetween: 24,
			loop: true,
			initialSlide: 0,
			dotsClass: 'slider-dots',
			dots: true,
			pagination: {
				el: '.slider-dots-wrapper',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				el: '.slider-arrows-wrapper',
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				576: {
					slidesPerView: 1,
					spaceBetween: 24,
				},
				767: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
		});
	}
}

// The document is checked if it is ready. If it is, the setup() method is called.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	ReviewSlider.setup();
} else {
	document.addEventListener('DOMContentLoaded', ReviewSlider.setup);
}
